import { Box, Paper, Typography, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { GameSessionModeCategoryContent } from "../../types/api";
import SwipeableRevealCard from "./SwipeableRevealCard";

interface ImposterRevealStepProps {
  currentPlayerNumber: number;
  isWaiting: boolean;
  isCurrentPlayerImposter: boolean;
  content: GameSessionModeCategoryContent;
  contentImage: string | null;
  imposterModeIcon: string | null;
  swipeOffset: number;
  onTouchStart: (e: React.TouchEvent) => void;
  onTouchMove: (e: React.TouchEvent) => void;
  onTouchEnd: () => void;
  onMouseDown: (e: React.MouseEvent) => void;
}

const ImposterRevealStep: React.FC<ImposterRevealStepProps> = ({
  currentPlayerNumber,
  isWaiting,
  isCurrentPlayerImposter,
  content,
  contentImage,
  imposterModeIcon,
  swipeOffset,
  onTouchStart,
  onTouchMove,
  onTouchEnd,
  onMouseDown,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const neonPalette = (theme.palette as any).neon;

  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: theme.palette.background.paper,
        border: `4px solid ${neonPalette.blue}`,
        borderRadius: 3,
        boxShadow: `0 8px 32px ${neonPalette.blue}60, 0 4px 16px ${neonPalette.blue}30, inset 0 0 20px ${neonPalette.blueLight}20`,
        overflow: "visible",
      }}
    >
      <Box sx={{ p: 4 }}>
        <Paper
          elevation={0}
          sx={{
            mb: 4,
            p: 2,
            backgroundColor: neonPalette.blueLight,
            border: `2px solid ${neonPalette.blue}`,
            borderRadius: 2,
            boxShadow: `0 4px 12px ${neonPalette.blue}40`,
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: theme.palette.text.primary,
              textAlign: "center",
            }}
          >
            {isWaiting
              ? `${t("imposter.player")} ${currentPlayerNumber} - ${t("imposter.revealBySwipe")}`
              : `${t("imposter.player")} ${currentPlayerNumber}`}
          </Typography>
        </Paper>

        <SwipeableRevealCard
          isWaiting={isWaiting}
          isCurrentPlayerImposter={isCurrentPlayerImposter}
          content={content}
          contentImage={contentImage}
          imposterModeIcon={imposterModeIcon}
          swipeOffset={swipeOffset}
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
          onMouseDown={onMouseDown}
        />

        {/* Instructions after reveal */}
        {!isWaiting && (
          <Paper
            elevation={0}
            sx={{
              p: 2,
              backgroundColor: neonPalette.aquaLight,
              border: `2px solid ${neonPalette.aqua}`,
              borderRadius: 2,
              boxShadow: `0 4px 12px ${neonPalette.aqua}40`,
              mb: 4,
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.text.primary,
                textAlign: "center",
                fontWeight: 600,
              }}
            >
              {t("imposter.swipeAndGiveToNext")}
            </Typography>
          </Paper>
        )}
      </Box>
    </Paper>
  );
};

export default ImposterRevealStep;
